import { render, staticRenderFns } from "./IconDesktop.vue?vue&type=template&id=24234b74&"
import script from "./IconDesktop.vue?vue&type=script&lang=js&"
export * from "./IconDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24234b74')) {
      api.createRecord('24234b74', component.options)
    } else {
      api.reload('24234b74', component.options)
    }
    module.hot.accept("./IconDesktop.vue?vue&type=template&id=24234b74&", function () {
      api.rerender('24234b74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDesktop.vue"
export default component.exports